<div class="progress-strip-card">
  <div class="progress-strip-header">
    <div class="left-group">
      <span class="label">{{ leftLabel }}</span>
      <span class="value">{{ leftValueLabel }}</span>
    </div>
    <span class="right-value">{{ rightValueLabel }}</span>
  </div>

  <div
    class="slider-wrap"
    [style.height]="containerHeight"
    #track
    (pointerdown)="onTrackPointerDown($event, track)"
    (pointermove)="onTrackPointerMove($event, track)"
    (pointerup)="onTrackPointerUp($event, track)"
    (pointercancel)="onTrackPointerUp($event, track)"
  >
    <div class="slider-track"></div>
    <span class="marker-value marker-top" [style.left.%]="markerPercent">{{ markerValue }}</span>
    <span class="dot" [style.left.%]="markerPercent"></span>
    <span class="marker-sub-value marker-bottom" [style.left.%]="markerPercent">{{ markerSubValue }}</span>
  </div>
</div>
